<!-- src/components/layout/SubscriptionBanner.vue -->
<template>
  <div
    v-if="access.shouldShowBanner"
    class="dq-subscription-banner-wrap"
  >
    <div
      class="alert alert-warning dq-subscription-banner d-flex align-items-center justify-content-between mb-0"
    >
      <div class="dq-subscription-banner-text">
        <strong v-if="access.trialEndingSoon">Your trial is ending soon.</strong>
        <strong v-else-if="access.gracePeriodActive">Your annual license is in grace period.</strong>
        <strong v-else>Subscription notice.</strong>
        <span class="ms-1">
          {{ message }}
        </span>
      </div>
      <div class="d-flex align-items-center gap-2 flex-shrink-0">
        <router-link to="/billing" class="btn btn-sm btn-dark">Open Billing</router-link>
        <button
          type="button"
          class="dq-subscription-close"
          aria-label="Close subscription notice"
          title="Close"
          @click="close"
        >
          <i class="ti ti-x"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useAccessStore } from "@/stores/accessStore";

export default {
  name: "SubscriptionBanner",
  setup() {
    const access = useAccessStore();
    const message = computed(() => {
      if (access.trialEndingSoon) {
        return access.trialEndsAt
          ? `Your free trial ends on ${new Date(access.trialEndsAt).toLocaleDateString()}.`
          : "Please choose a plan and prepare to activate billing.";
      }
      if (access.gracePeriodActive) {
        return access.graceRemainingText
          ? `You have ${access.graceRemainingText} remaining to renew your licence.`
          : "Renew now to avoid the workspace being locked.";
      }
      return "Please review your subscription status.";
    });

    const close = () => {
      access.dismissBanner();
    };

    return { access, close, message };
  },
};
</script>

<style scoped>
.dq-subscription-banner-wrap {
  margin-left: 252px;
  margin-top: 50px;
  padding: 12px 24px 0;
}

.dq-subscription-banner {
  border-radius: 14px;
  border: 1px solid rgba(255, 193, 7, 0.28);
}

.dq-subscription-banner-text {
  min-width: 0;
  padding-right: 12px;
}

.dq-subscription-close {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.08);
  color: #0f172a;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.dq-subscription-close:hover {
  background: rgba(15, 23, 42, 0.14);
}

.dq-subscription-close:focus-visible {
  outline: 2px solid rgba(15, 23, 42, 0.35);
  outline-offset: 2px;
}

@media (max-width: 991.98px) {
  .dq-subscription-banner-wrap {
    margin-left: 0;
    padding: 12px 15px 0;
  }

  .dq-subscription-banner {
    align-items: flex-start !important;
    gap: 12px;
    flex-direction: column;
  }
}
</style>
